import React from "react";
import { XIcon } from "@heroicons/react/solid";
import axios from "axios";
import useState from "react-usestateref";
import backendService from "../services.js/backendService";
import { PuffLoader } from "react-spinners";
import { useFileUpload } from "use-file-upload";
import { toast } from "react-toastify";
import toastProp from "../global/toastProps";
import ProgressBar from "@ramonak/react-progress-bar";
import { Line, Circle } from "rc-progress";


function UploadFileModal({ openUploadFileModal }) {
  const [file, selectFile] = useFileUpload();
  const [progress, setProgress, progressRef] = useState(0);

  const [loading, setLoading] = useState(false);

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="w-11/12 sm:w-3/4 md:w-1/2 lg:w-1/3 relative my-6 mx-auto max-w-md rounded-md">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-md shadow-black relative flex flex-col w-full  outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5  border-blueGray-200 rounded-t bg-background">
              <h3 className="text-3xl font-robo text-primary ">Upload File</h3>
              {!loading ? (
                <div className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full">
                  <XIcon
                    className="h-5 w-5 "
                    aria-hidden="true"
                    onClick={() => openUploadFileModal(false)}
                  />
                </div>
              ) : null}
            </div>
            {/*body*/}
            <div className=" px-6  pb-2 flex justify-center items-center bg-background">
              <button
                className=" bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                type="button"
                disabled={loading ? true : false}
                onClick={() => {
                  selectFile(
                    { accept: "*/*" },
                    ({ source, name, size, file }) => {
                      const config = {
                        onUploadProgress: (progressEvent) => {
                          setProgress(
                            (progressEvent.loaded / progressEvent.total) * 100
                          );
                        },
                      };

                      if (size > 15000000) {
                        toast.error(
                          "File size is too large. Please upload a file less than 15mb",
                          { theme: "light" }
                        );
                        return;
                      }

                      const formData = new FormData();
                      formData.append("file", file);
                      setLoading(true);
                      axios
                        .post(
                          `${process.env.REACT_APP_URL}/uploadtocodespace`,
                          formData,
                          config,
                          {
                            headers: {
                              "Content-Type": "multipart/form-data",
                              "x-auth-token": backendService.getToken(),
                            },
                          }
                        )
                        .then((res) => {
                          toast.success(
                            `${name} has been uploaded successfully`,
                            { theme: "light" }
                          );
                          openUploadFileModal(false);
                          setLoading(false);
                        })
                        .catch((err) => {
                          toast.error("Upload Failed", { theme: "light" });
                          openUploadFileModal(false);
                          setLoading(false);
                        });
                    }
                  );
                }}
              >
                {loading ? `Uploading ${file.name} ...` : "Upload"}
              </button>
            </div>
            {/*footer*/}
            {loading && (
              <div className="flex  items-center justify-center p-3  pr-6  border-blueGray-200 rounded-b bg-background">
                {/* <ProgressBar
              className="w-full"
                completed={Math.floor(progressRef.current)}
                bgColor="#3b3939"
                labelColor="#EEEDDE"
                labelSize=""
                maxCompleted={100}
              /> */}
                <Line
                  className="w-[80%]"
                  percent={Math.floor(progressRef.current)}
                  strokeWidth={4}
                  trailWidth={2}
                  strokeColor="#0077b6"
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <div className="opacity-50  fixed inset-0 z-10 bg-black"></div> */}
    </>
  );
}

export default UploadFileModal;
